module.exports = __webpack_public_path__ + "static/media/successDonation.c2816f88.png";